import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from './config';
import { Version } from './version';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private readonly configJsonPath = `../assets/config/config.json`;
  private readonly versionPath = `../assets/json/version-infos.json`;
  public config: Config;
  public version: Version;
  private route = inject(ActivatedRoute);

  constructor(private handler: HttpBackend) { }

  public loadConfigFromJson(): Observable<Config> {
    return new HttpClient(this.handler).get<Config>(this.configJsonPath)
      .pipe(tap(configuration => this.config = configuration));
  }
  public loadVersionFromJson(): Observable<Version> {
    return new HttpClient(this.handler).get<Version>(this.versionPath)
      .pipe(tap(version => this.version = version));
  }

  public isFusionAuthConfigured(): boolean {
    return this.config?.fusionAuthAppID !== "null" && this.config?.fusionAuthAppID !== "" &&
      this.config?.fusionAuthUrl !== "null" && this.config?.fusionAuthUrl !== "" &&
      this.config?.fusionAuthAppID !== "null" && this.config?.fusionAuthAppID !== "";
  }

  public getFusionAuthUrl(returnUrl: string): string {
    if (!this.isFusionAuthConfigured()) {
      throw new Error('FusionAuth configuration is missing.');
    }
    const { fusionAuthUrl, fusionAuthAppID, clientDomain, fusionAuthIdP } = this.config;
    if(clientDomain.includes('localhost')) {      
      if (fusionAuthIdP && !this.route.snapshot.queryParams.interne) {
        return `${fusionAuthUrl}/oauth2/authorize?client_id=${fusionAuthAppID}&idp_hint=${fusionAuthIdP}&response_type=token&redirect_uri=http://${clientDomain}/login/FusionAuth&state=${encodeURIComponent(returnUrl)}`
      } else {
        return `${fusionAuthUrl}/oauth2/authorize?client_id=${fusionAuthAppID}&response_type=token&redirect_uri=http://${clientDomain}/login/FusionAuth&state=${encodeURIComponent(returnUrl)}`;
      }    
    }
    if (fusionAuthIdP && !this.route.snapshot.queryParams.interne) {
        return `${fusionAuthUrl}/oauth2/authorize?client_id=${fusionAuthAppID}&idp_hint=${fusionAuthIdP}&response_type=token&redirect_uri=https://${clientDomain}/login/FusionAuth&state=${encodeURIComponent(returnUrl)}`
    } else {
      return `${fusionAuthUrl}/oauth2/authorize?client_id=${fusionAuthAppID}&response_type=token&redirect_uri=https://${clientDomain}/login/FusionAuth&state=${encodeURIComponent(returnUrl)}`;
    }
  }

  public getFusionAuthLogoutUrl(returnUrl: string): string {
    if (!this.isFusionAuthConfigured()) {
      throw new Error('FusionAuth configuration is missing.');
    }
    const { fusionAuthUrl, fusionAuthAppID, clientDomain } = this.config;
    if (clientDomain.includes('localhost')) {
      return `${fusionAuthUrl}/oauth2/logout?client_id=${fusionAuthAppID}&redirect_uri=http://${clientDomain}/login/FusionAuth`;
    }
    const loginUrl = `${fusionAuthUrl}/oauth2/logout?client_id=${fusionAuthAppID}&redirect_uri=https://${clientDomain}/login/FusionAuth`;
    return loginUrl;
  }

}
